var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1590.53 683.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0f0ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Logo",
    "data-name": "White Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 228.18,
    cy: 148.65,
    r: 61.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.81,524.38V230.73h278.31s-19.45,83.06-140.86,108.85c0,0,3.33,104.97-137.45,184.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Placify"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.72,230.25h59.69c32.54,0,59.69,24.5,59.69,55.37s-26.56,56.06-59.69,56.06h-17.74v46.55h-41.95v-157.99ZM597.62,285.82c0-9.6-8.04-16.86-19.21-16.86h-17.74v34.01l17.74.1c11.27.1,19.21-7.55,19.21-17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M763.37,348.84v39.4h-102.42v-157.99h41.95v118.59h60.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.47,369.81h-59l-8.04,18.43h-45.87l73.41-159.95h19.9l73.5,159.95h-45.96l-7.94-18.43ZM871.14,339.13l-16.17-37.44-16.27,37.44h32.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M937.26,309.24c0-46.75,37.83-82.72,87.03-82.72,20.39.29,42.24,9.21,58.41,23.91l-24.11,30.97c-9.7-8.82-22.54-14.6-34.2-14.6-24.31,0-44.59,18.52-44.59,42.73s21.17,42.53,43.71,42.53c13.23,0,25.09-6.27,35.28-15.39l23.91,31.85c-15.09,13.72-35.18,23.23-59.2,23.23-44.59,0-86.25-32.93-86.25-82.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1102.55,230.25h41.95v157.99h-41.95v-157.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1215.41,269.26v25.58h50.18v35.09h-50.18v58.51h-41.46v-158.58h102.42v39.4h-60.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1333.27,320.02l-48.71-89.77h47.53l22.05,45.77,21.95-45.77h47.63l-48.81,89.77v68.21h-41.65v-68.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Innovative"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.55,418.76h16.58v105.62h-16.58v-105.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.7,418.5v107.72h-.79l-67.55-70.57v68.86h-16.58v-107.59h.85l67.42,70.44v-68.86h16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.28,418.5v107.72h-.79l-67.55-70.57v68.86h-16.58v-107.59h.85l67.42,70.44v-68.86h16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M764.9,471.7c0-30.14,24.5-54.78,54.58-54.78s54.65,24.64,54.65,54.78-24.64,54.38-54.71,54.38-54.51-24.5-54.51-54.38ZM857.35,471.57c0-20.9-17.1-37.94-37.94-37.94s-37.81,17.04-37.81,37.94,16.97,37.74,37.81,37.74,37.94-16.97,37.94-37.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.44,418.76l-48.75,107.78h-1.11l-48.55-107.78h17.62l31.45,71.48,31.58-71.48h17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1051.97,508.33h-49.99l-7.21,16.05h-17.95l49.67-107.78h.98l49.67,107.78h-17.95l-7.21-16.05ZM1045.55,494.11l-18.54-41.28-18.61,41.28h37.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1156.39,435.2h-28.3v89.17h-16.64v-89.17h-28.31v-16.45h73.25v16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.91,418.76h16.58v105.62h-16.58v-105.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1298.91,418.76l-48.75,107.78h-1.11l-48.55-107.78h17.62l31.45,71.48,31.58-71.48h17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.56,435.07v27.06h39.97v16.51h-39.97v29.22h46.32v16.51h-62.9v-105.62h62.9v16.31h-46.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.55,418.76h16.58v105.62h-16.58v-105.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.7,418.5v107.72h-.79l-67.55-70.57v68.86h-16.58v-107.59h.85l67.42,70.44v-68.86h16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.28,418.5v107.72h-.79l-67.55-70.57v68.86h-16.58v-107.59h.85l67.42,70.44v-68.86h16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M764.9,471.7c0-30.14,24.5-54.78,54.58-54.78s54.65,24.64,54.65,54.78-24.64,54.38-54.71,54.38-54.51-24.5-54.51-54.38ZM857.35,471.57c0-20.9-17.1-37.94-37.94-37.94s-37.81,17.04-37.81,37.94,16.97,37.74,37.81,37.74,37.94-16.97,37.94-37.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.44,418.76l-48.75,107.78h-1.11l-48.55-107.78h17.62l31.45,71.48,31.58-71.48h17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1051.97,508.33h-49.99l-7.21,16.05h-17.95l49.67-107.78h.98l49.67,107.78h-17.95l-7.21-16.05ZM1045.55,494.11l-18.54-41.28-18.61,41.28h37.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1156.39,435.2h-28.3v89.17h-16.64v-89.17h-28.31v-16.45h73.25v16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.91,418.76h16.58v105.62h-16.58v-105.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1298.91,418.76l-48.75,107.78h-1.11l-48.55-107.78h17.62l31.45,71.48,31.58-71.48h17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.56,435.07v27.06h39.97v16.51h-39.97v29.22h46.32v16.51h-62.9v-105.62h62.9v16.31h-46.32Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.75dd6d871005d500b6bec0282cb46da2.svg";
export { ForwardRef as ReactComponent };